import { render, staticRenderFns } from "./signupData.vue?vue&type=template&id=71604584&scoped=true"
import script from "./signupData.vue?vue&type=script&lang=js"
export * from "./signupData.vue?vue&type=script&lang=js"
import style0 from "./signupData.vue?vue&type=style&index=0&id=71604584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71604584",
  null
  
)

export default component.exports